import { generateUUID } from '../helpers';

const apiConfig = {
  sessionId: generateUUID()
}

Object.freeze(apiConfig)

export default apiConfig